<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a target="_blank" href="https://www.lipsum.com/">
              Privacy Policy
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; Copyright 2018 Authentic.net
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue